import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const orientationModuleGroupService = {
    getAll,
    show,
    update,
    updateSequence,
};

const MODULE = {
    ORIENTATION_MODULE_GROUP: 'orientation-module-groups',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            header: filter?.header,
            is_active: filter?.isActive,
        },
    };

    return apiHelper(API_URL).get(`/${MODULE.ORIENTATION_MODULE_GROUP}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.ORIENTATION_MODULE_GROUP}/${uuid}`);
}

export function update (data) {
    const request = {
        header_uuid: data.headerUuid,
        sequence: data.sequence,
    };

    return apiHelper(API_URL).put(`/${MODULE.ORIENTATION_MODULE_GROUP}/${data.uuid}`, request);
}

export function updateSequence (data) {
    const request = {
        header_uuid: data.headerUuid,
    };

    if (data.groups.length) {
        request.groups = data.groups.map(item => ({
            uuid: item.uuid,
            sequence: item.sequence,
        }));
    }

    return apiHelper(API_URL).patch(`/${MODULE.ORIENTATION_MODULE_GROUP}/sequences`, request);
}